export class CONSTANTS {
    //public static get API_ENDPOINT(): string { return "http://localhost:9000/api"};
    public static get API_ENDPOINT(): string { return "https://localhost:8000/search"};
    //public static get API_ENDPOINT(): string { return "http://devavrata.ddns.net:8000/api"};
    //public static get API_ENDPOINT(): string { return "https://rdo.research.udel.edu/dashboard/api"};
}



// WEBPACK FOOTER //
// ./src/CONSTANTS.ts